import { render, staticRenderFns } from "./InputContact.vue?vue&type=template&id=dd83e826&scoped=true"
import script from "./InputContact.vue?vue&type=script&lang=js"
export * from "./InputContact.vue?vue&type=script&lang=js"
import style0 from "./InputContact.vue?vue&type=style&index=0&id=dd83e826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd83e826",
  null
  
)

export default component.exports